import { deviceType } from "constant";

export const isVdu3Or4Car = (carNumber, updatedCarDataString) => {
  try {
    if (!updatedCarDataString || Object.keys(updatedCarDataString).length == 0) return false;

    const parsedCarData = JSON.parse(updatedCarDataString);
    const car = parsedCarData?.filter(car => car?.Car?.CarNumber === carNumber);

    if (car?.length <= 0) {
      return false;
    }

    return (
      car[0]?.Car?.DevType === deviceType.VDU3 ||
      car[0]?.Car?.DevType === deviceType.VDU4
    );
  } catch (error) {
    console.error("Error parsing car data in isVdu3Or4Car:", error);
    return false;
  }
};
